export default "__VITE_ASSET__7AnBLNi6__"